//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




import Joi from "joi";
const schema = Joi.object().keys({
    username: Joi.string().regex(/^[a-zA-Z0-9_]*$/).min(6).max(13).required(),
    password: Joi.string().min(6).required(),
});






import UMUM from "../../library/umum";
import FETCHING from "../../library/fetching";
import uniqid from 'uniqid';




export default {
    data() {
        return {
            key: '',
            modal_add : false,
            modal_edit : false,
            modal_lihat : false,
            modal_lampiran : false,

            form : {
              nama : '',
              tpt_lahir : '',
              tgl_lahir : '',
              jk : '',
              agama : '',
              alamat : '',
              des_kel : '',
              jns_usaha : '',
              status_tpt_usaha : '',
              thn_kepemilikan : '2022',
              alamat_usaha : '',
              no : '',
              file : null,
              createdAt : '',
              editedAt : '',
              status : 0,
              agenda : false,
              keterangan : 'Masih dalam proses pemeriksaan',
              penandatangan : '',
            },

            uraian : {
              agama_uraian : '',
            },

            fileOld : '',

            UMUM : UMUM,
            FETCHING : FETCHING,
            LIST_AGAMA : [],
            LIST_DATA : [],

        }
    },

    methods: {
        openModal() {
            this.notify("Upss..!! 😅", 'Mohon maaf layanan belum kami aktifkan', 'warning')
        },

        routex : function(routeName){
                this.$router.push('/'+routeName);
        },

        hrefku(data){
          window.open(
            data,
            '_blank' // <- This is what makes it open in a new window.
          );
        },



        getView : function(){
          this.$store.commit("shoWLoading");
          fetch(this.$store.state.url.URL_srv_suketUsaha + "view", {
              method: "POST",
              headers: {
              "content-type": "application/json",
              authorization: "kikensbatara " + localStorage.token
              },
              body: JSON.stringify({
                  des_kel : this.form.des_kel
              })
          })
              .then(res => res.json())
              .then(res_data => {
                  this.list_data = res_data.data;
                  this.page_last = res_data.jmlData;
                  this.$store.commit("hideLoading");

                  this.LIST_DATA = res_data
                  console.log(res_data);
          });
        },


        addData : function(number) {

            this.form.createdAt = UMUM.NOW()

            // console.log(this.form)
            var formData = new FormData();

            formData.append("form", JSON.stringify(this.form));
            formData.append("file", this.form.file);


            fetch(this.$store.state.url.URL_srv_suketUsaha + "addData", {
                method: "POST",
                headers: {
                    // "content-type": "application/json",
                    authorization: "kikensbatara " + localStorage.token
                },
                body: formData
            }).then(res_data => {
                this.notify("SUKSES", 'Anda berhasil mengajukan permohonan 😁', 'success')
                this.getView();
            });

            // console.log(document.getElementById("editor").value)
        },


        editData : function(){

          var formData = new FormData();


            this.form.editedAt = UMUM.NOW()
            formData.append("form", JSON.stringify(this.form));
            formData.append("file", this.form.file);
            formData.append("fileOld", this.fileOld);


          fetch(this.$store.state.url.URL_srv_suketUsaha + "editData", {
              method: "POST",
              headers: {
                // "content-type": "application/json",
                authorization: "kikensbatara " + localStorage.token
              },
              body: formData
          }).then(res_data => {
              this.notify("SUKSES", 'Anda berhasil mengubah permohonan 😁', 'success')
              this.getView();
          });
        },

        removeData : async function(E){

          const confirm = await UMUM.NoticeRemoveData()
          if (confirm) {

            fetch(this.$store.state.url.URL_srv_suketUsaha + "removeData", {
                method: "POST",
                headers: {
                  "content-type": "application/json",
                  authorization: "kikensbatara " + localStorage.token
                },
                body: JSON.stringify({
                    id : this.form.id,
                    fileOld : this.fileOld,
                })
            }).then(res_data => {
                this.notify("SUKSES", 'Anda berhasil menghapus permohonan 😁', 'success')
                this.getView();
            });
          } 



        },
        selectData : function(data){


                this.form.id = data.data.id;
                this.form.nama= data.data.nama;
                this.form.tpt_lahir= data.data.tpt_lahir;
                this.form.tgl_lahir= data.data.tgl_lahir;
                this.form.jk= data.data.jk;
                this.form.agama= data.data.agama;
                this.form.alamat= data.data.alamat;
                this.form.createdAt= data.data.createdAt;
                this.form.editedAt = data.data.editedAt;
                this.form.status= data.data.status;
                this.form.no= data.data.no;
                this.form.jns_usaha = data.data.jns_usaha;
                this.form.status_tpt_usaha = data.data.status_tpt_usaha;
                this.form.thn_kepemilikan = data.data.thn_kepemilikan;
                this.form.alamat_usaha = data.data.alamat_usaha;

                this.form.keterangan= data.data.keterangan;
                this.fileOld = data.data.file;

                this.uraian.agama_uraian = data.agama.uraian;

                this.form.penandatangan = data.pegawai.nama;

                // console.log(data.file)

                // console.log(this.form)
        },

        logOut :function(){
            localStorage.removeItem("token");
            localStorage.removeItem("profile");
            this.$store.state.CHECK_AUTH = false;
            this.$store.state.userx.nama = '';
            this.$store.state.userx.email = '';
            this.$store.state.userx.hp = ''
        },


        notify(sukses, notif, icon){
            Swal.fire(
            sukses,
            notif,
            icon,

            )
        },



        fetchLIB : async function(){
          this.LIST_AGAMA = await FETCHING.postDataPublishAuth(this.$store.state.url.URL_MASTER_AGAMA, 'list', {id : ''})

          // console.log(this.LIST_AGAMA)
        },

    },

    mounted () {
      this.fetchLIB();
      this.form.des_kel = this.$store.state.ID_DES_KEL;

      this.getView();
    },

}
